(function () {
	var blocks = document.querySelectorAll('.block-savings-calculator .range-slider');
	if (!blocks.length) return;
  
	blocks.forEach(function (range) {
	  var input = range.querySelector('.range-input');
	  var sliderNumbers  = range.querySelectorAll('.slider-display .calc-number');
	  var savingsNumbers = range.querySelectorAll('.range-display .calc-number');
	  var display = range.querySelector('.slider-display');
  
	  if (!input) return;
  
	  set(0);
	  move(0);
  
	  input.addEventListener('input', function () {
		var i = parseInt(input.value, 10) || 0;
		set(i);
		move(i);
	  });
  
	  function set(index) {
		sliderNumbers.forEach(function (n) { n.classList.remove('active'); });
		savingsNumbers.forEach(function (n) { n.classList.remove('active'); });
		if (sliderNumbers[index]) sliderNumbers[index].classList.add('active');
		if (savingsNumbers[index]) savingsNumbers[index].classList.add('active');
	  }
  
	  function move(index) {
		if (!display) return;
		var max = parseInt(input.max, 10) || (sliderNumbers.length ? sliderNumbers.length - 1 : 5);
		var offset = window.innerWidth < 640 ? 6 : 1.75;
		var percentage = (100 / max) - offset;
		display.style.left = (index * percentage) + '%';
	  }
	});
  })();  